import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import { isSessionExpired } from '@/common/utils/SessionTimeout';
// import SignSvc from '@/common/service/SignSvc'

/** 미들웨어(auth check) */
import isLogin from './middleware/isLogin.js';
import isMaster from './middleware/isMaster.js';
import isTicket from './middleware/isTicket.js';
import middlewarePipeline from './middlewarePipeline.js';

const updateRouteLayout = async (meta) => {
  await store.dispatch('layout/updateRouteLayout', {
    isHeader: meta.isHeader,
    titleName: meta.titleName,
    isFooter: meta.isFooter,
    isBack: meta.isBack,
    isNav: meta.isNav
  });
};

const beforeLoginAndJoinEnter = async (to, from, next) => {
  const isAuthenticated = store.getters['expert/getIsAuthenticated'];

  if (!isAuthenticated) {
    next();
    return;
  }

  if (isSessionExpired()) {
    await store.dispatch('expert/expireSession');
    next();
    return;
  }

  next('/');
  // if (expertData.isTicket === 0) {
  //   next()
  // } else {
  //   next('/')
  // }
};

// const changeToken = async () => {
//   await SignSvc.postMapChangeToken()
// }

const routes = [
  {
    path: '/',
    name: 'MainIndex',
    component: () => import('@/views/main/index.vue'),
    meta: {
      middleware: [isLogin, isTicket]
    }
  },
  {
    path: '/expert/login',
    name: 'ExpertLogin',
    description: '로그인',
    component: () => import('@/views/expert/login.vue'),
    beforeEnter: beforeLoginAndJoinEnter
  },
  {
    path: '/expert/join',
    name: 'ExpertJoin',
    description: '회원가입',
    component: () => import('@/views/expert/join.vue'),
    beforeEnter: beforeLoginAndJoinEnter
  },
  {
    path: '/expert/find',
    name: 'ExpertFind',
    description: '전문가 회원 ID/PW 찾기 페이지',
    component: () => import('@/views/expert/find.vue')
  },
  {
    path: '/expert/register',
    name: 'ExpertRegister',
    description: '티켓 등록',
    component: () => import('@/views/expert/register.vue')
  },
  {
    path: '/client-care',
    name: 'ClientCareIndex',
    component: () => import('@/views/client-care/index.vue'),
    meta: {
      middleware: [isLogin, isTicket]
    }
  },
  {
    path: '/insurance-claim-history',
    name: 'InsuranceClaimHistoryIndex',
    component: () => import('@/views/insurance-claim-history/index.vue'),
    meta: {
      middleware: [isLogin, isTicket, isMaster]
    }
  },
  {
    path: '/my-page',
    name: 'MyPageIndex',
    component: () => import('@/views/my-page/index.vue'),
    meta: {
      middleware: [isLogin, isTicket]
    }
  },
  {
    path: '/service',
    name: 'ServiceIndex',
    component: () => import('@/views/service/index.vue'),
    meta: {
      middleware: [isLogin, isTicket]
    }
  },
  {
    path: '/service/view',
    name: 'ServiceView',
    component: () => import('@/views/service/view.vue'),
    meta: {
      middleware: [isLogin, isTicket]
    }
  },
  {
    path: '/popup/security-entry',
    name: 'PopupSecurityEntry',
    props: true,
    component: () => import('@/views/popup/security-entry/index.vue'),
    meta: {
      isHeader: false,
      titleName: '',
      isFooter: false,
      isBack: false,
      isNav: false,
      middleware: [isLogin, isTicket]
    }
  }
  // {
  //   path: '/test1',
  //   name: 'Test1',
  //   component: () => import('@/views/Test1.vue'),
  //   children: [
  //     {
  //       path: 'test2',
  //       name: 'Test2',
  //       component: () => import('@/views/Test2.vue'),
  //       children: [
  //         {
  //           path: 'test3',
  //           name: 'Test3',
  //           component: () => import('@/views/Test3.vue')
  //         }
  //       ]
  //     }
  //   ]
  // }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  let meta = to.meta;
  updateRouteLayout(meta)
    .then(() => {
      if (!meta.middleware) {
        return next();
      }
      const middleware = meta.middleware;

      const context = {
        to,
        from,
        next,
        store
      };
      return middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1)
      });
    })
    .catch((error) => {
      next(error);
    });
  // next()
});

export default router;
